// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { Spinner } from './Spinner';

export const LoadingSpinner = styled(Spinner)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%);
`;
